goog.provide("shadow.js.shim.module$dayjs$locale$cs");
goog.provide("module$shadow_js_shim_module$dayjs$locale$cs");
shadow.js.shim.module$dayjs$locale$cs = shadow.js.nativeProvides["dayjs/locale/cs"] = require("dayjs/locale/cs");
module$shadow_js_shim_module$dayjs$locale$cs.default = shadow.js.shim.module$dayjs$locale$cs;
